<!--  -->
<template>
  <div :data-clipboard-text="copyText" @click="handeCopy" class="handeCopy">复制</div>
</template>

<script>
import { Toast } from 'vant';
import Clipboard from 'clipboard';

export default {
  name: 'handeCopy',
  data() {
    return {

    };
  },
  props: {
    copyText: {
      type: String,
    },
  },
  methods: {
    handeCopy() {
      const clipboard = new Clipboard('.handeCopy');
      console.log(clipboard);
      clipboard.on('success', () => {
        Toast('复制成功');
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on('error', () => {
        // 不支持复制 console.log('该浏览器不支持自动复制')
        // 释放内存
        clipboard.destroy();
      });
    },
  },
};
</script>
<style scoped>
</style>
